export default "__VITE_ASSET___sqWd_Nl__"